import { RadioInputWrapper, StyledRadioInput } from './styles'

interface RadioFieldProps {
  value: any
  inputId?: string
  isChecked: boolean
  name: string
  onChange: any
}

function RadioField({ ...props }: RadioFieldProps) {
  return (
    <RadioInputWrapper>
      <StyledRadioInput
        type="radio"
        id={props.inputId}
        value={props.value}
        name={props.name}
        checked={props.isChecked}
        onChange={props.onChange}
      />
    </RadioInputWrapper>
  )
}

export default RadioField
